import React, { useState, useEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import {
  Pagination,
  Input,
  Dimmer,
  Loader,
  Message,
  Divider,
  Dropdown,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { PERSONAS, PERSONA_OPTIONS } from "members/audit/Personas.js";

import { useNavigate } from "react-router-dom";

import TableList from "./TableList";
import RedirectLink from "../RedirectLink";

import {
  SG_GET_EMPLOYEE_CATEGORIES,
  SG_GET_EMPLOYEE_ORG_CATEGORIES,
  SG_SET_MEMBER_SEARCH_FILTERS,
  LOAD_EMPLOYEES,
  SG_GET_SURVEY_STRUCTURES,
} from "constants/actions";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { PlusIcon, UploadGroupIcon, RefreshIcon } from "./Icons";
import Filter from "./Filter";
import MemberIcon from "assets/images/nav/member.svg";
import ModernFilter from "./ModernFilter";  

const MemberDirectory = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    setTeamUpdate,
    userAdmin,
    userEmployee,
    changesMade,
    setChangesMade,
  } = props;
  const [members, setMembers] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [teamLeader, setTeamLeader] = useState(false);
  const [administrator, setAdministrator] = useState(false);

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [categoryOrdering, setCategoryOrdering] = useState("employee__first_name");

  // Refs to track previous values for loading state
  const prevPageRef = useRef(undefined);
  const prevItemsPerPageRef = useRef(undefined);
  const prevCategoryOrderingRef = useRef(undefined);
  const prevDataRef = useRef(undefined);
  const [isLoadingPage, setIsLoadingPage] = useState(false);

  const [selectTeam, setSelectTeam] = useState(false);

  const [organization, setOrganization] = useState({});
  const [auditEnabled, setAuditEnabled] = useState(false);
  const [teamToolEnabled, setTeamToolEnabled] = useState(false);

  const createdTeam = useSelector((state) => state.teams.created, shallowEqual);

  const [addUploadUsers, setAddUploadUsers] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterCategories, setFilterCategories] = useState([]);
  const [filteredCategoriesSelected, setFilteredCategoriesSelected] = useState(
    []
  );
  const [employeeCategories, setEmployeeCategories] = useState([]);
  const [userFilteredCategories, setUserFilteredCategories] = useState();
  const [filteredPermissions, setFilteredPermissions] = useState([]);
  const [missingCategoriesFilter, setMissingCategoriesFilter] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canAccessData, setCanAccessData] = useState();
  const [currentUser, setCurrentUser] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [membersFiltered, setMembersFiltered] = useState(false);
  const [hideMembers, setHideMembers] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const [pdfEnabled, setPDFEnabled] = useState(false);
  const [persona, setPersona] = useState();
  const [timeoutReached, setTimeoutReached] = useState(false);

  const EmployeeId = useSelector(
    (state) => state.auth?.employee_id,
    shallowEqual
  );
  const AmbassadorId = useSelector(
    (state) => state.auth?.ambassador_id,
    shallowEqual
  );

  const memberFilters = useSelector(
    (state) => state.member_filters,
    shallowEqual
  );

  const {
    get_organizations,
    get_employees,
    get_auth,
    get_teams,
    get_selectedOrg,
    get_survey_structure,
    get_employee_org_category,
    get_employee_org_category_pagination,
    employee_org_permission,
    categoriesFetched,
  } = useSelector(
    (state) => ({
      get_error: state.errors,
      employees_data: state.employees.employees,
      get_auth: state.auth,
      get_employee_user_category:
        state.employee_category.employee_user_category,
      get_employees: state.employees,
      get_organizations: state.organizations,
      get_teams: state.teams,
      get_departments: state.departments,
      get_selectedOrg: state.selectedOrg,
      get_survey_structure: state.surveystructure.survey_structure,
      get_employee_org_category: state.employee_category?.employee_org_category,
      get_employee_org_category_pagination: state.employee_category?.employee_org_category_pagination || { count: 0, next: null, previous: null },
      categoriesFetched: state.employee_category?.fetched,
      get_org_category: state.employee_category,
      employee_org_permission: state.employee_permission,
    }),
    shallowEqual
  );

  // Dispatch Calls - Load required data on mount and when page, itemsPerPage, or categoryOrdering changes
  useEffect(() => {
    if (get_auth?.organization_id) {
      // Check if page, itemsPerPage, or categoryOrdering changed (not initial load)
      const pageChanged = prevPageRef.current !== page;
      const itemsPerPageChanged = prevItemsPerPageRef.current !== itemsPerPage;
      const orderingChanged = prevCategoryOrderingRef.current !== categoryOrdering;

      // Set loading state if pagination/ordering changed (but not on initial mount)
      if ((pageChanged || itemsPerPageChanged || orderingChanged) && prevPageRef.current !== undefined) {
        setIsLoadingPage(true);
      }

      const baseQuery = [
        `organization=${get_auth.organization_id}`,
        `page_size=${itemsPerPage}`,
        `page=${page}`,
        `ordering=${categoryOrdering}`,
      ].join("&");

      dispatch({
        type: SG_GET_EMPLOYEE_ORG_CATEGORIES,
        payload: baseQuery,
      });

      // Update refs after dispatch
      prevPageRef.current = page;
      prevItemsPerPageRef.current = itemsPerPage;
      prevCategoryOrderingRef.current = categoryOrdering;
    } else {
      dispatch({ type: SG_GET_EMPLOYEE_CATEGORIES });
    }

    if (!get_survey_structure?.[0]) {
      dispatch({ type: SG_GET_SURVEY_STRUCTURES, payload: `organization=${get_auth?.organization_id}` });
    }
  }, [dispatch, get_auth, page, itemsPerPage, categoryOrdering]);


  useEffect(() => {
    if (
      memberFilters?.search &&
      memberFilters?.search !== "" &&
      memberFilters?.search !== search &&
      ((memberList.length > 0 && memberList) || members) &&
      !isTyping
    ) {
      setTimeout(() => {
        setSearch(memberFilters?.search);
        searchMembers(memberFilters?.search);
      }, [200]);
    }
  }, [memberFilters, search]);

  useEffect(() => {
    if (get_auth?.employee_id) {
      if (get_employee_org_category?.length > 0) {
        const currentCategories = get_employee_org_category.find(
          (f) => f.employee_id === Number(get_auth?.employee_id)
        );
        setEmployeeCategories(currentCategories);
      }
    }
  }, [get_employee_org_category, get_auth?.employee_id]);

  useEffect(() => {
    if (get_employees.updated) {
      const timer1 = setTimeout(() => {
        // Refresh categories instead of employees since we're using categories as source
        if (get_auth?.organization_id) {
          const baseQuery = [
            `organization=${get_auth.organization_id}`,
            `page_size=${itemsPerPage}`,
            `page=${page}`,
            `ordering=${categoryOrdering}`,
          ].join("&");
          dispatch({
            type: SG_GET_EMPLOYEE_ORG_CATEGORIES,
            payload: baseQuery,
          });
        } else {
          dispatch({
            type: LOAD_EMPLOYEES,
          });
        }
      }, 500);
      return () => clearTimeout(timer1);
    }
  }, [get_employees.updated, dispatch, get_auth, itemsPerPage, page, categoryOrdering]);

  // Clear loading state when new data arrives
  useEffect(() => {
    if (isLoadingPage) {
      // Check if data has actually changed (new data arrived)
      const dataChanged = prevDataRef.current !== get_employee_org_category;
      const hasResponse = Array.isArray(get_employee_org_category);

      if (hasResponse && dataChanged) {
        // Clear loading state - new data has arrived
        setIsLoadingPage(false);
        prevDataRef.current = get_employee_org_category;
      }
    } else {
      // Update data ref even when not loading
      prevDataRef.current = get_employee_org_category;
    }
  }, [get_employee_org_category, isLoadingPage]);

  useEffect(() => {
    const optionsArray = [];
    if (
      currentUser &&
      isOtp &&
      userFilteredCategories &&
      get_survey_structure?.[0] &&
      employee_org_permission
    ) {
      currentUser?.access_data_analytics === 1 &&
        optionsArray.push(PERSONA_OPTIONS.access_datalytics);
      currentUser?.access_subfactor_data === 1 &&
        optionsArray.push(PERSONA_OPTIONS.access_subfactor);
      currentUser?.survey_add_users === 1 &&
        optionsArray.push(PERSONA_OPTIONS.edit_users);
      currentUser?.account_type === 5 &&
        optionsArray.push(PERSONA_OPTIONS.is_admin);
      currentUser?.enable_login === true &&
        optionsArray.push(PERSONA_OPTIONS.enable_login);
      currentUser?.read_feedback === 1 &&
        optionsArray.push(PERSONA_OPTIONS.read_feedback);
      currentUser?.survey_schedule === 1 &&
        optionsArray.push(PERSONA_OPTIONS.schedule_survey);
      currentUser?.survey_status === 1 &&
        optionsArray.push(PERSONA_OPTIONS.participate_survey);

      const primary = get_survey_structure[0]?.categories?.find(
        (c) => c.priority === "primary"
      );

      const newTeamArr = primary?.options.map((o) => {
        return o.id;
      });

      if (
        newTeamArr?.length > 0 &&
        newTeamArr.every((v) => userFilteredCategories.includes(v))
      ) {
        optionsArray.push(PERSONA_OPTIONS.otp_view);
        if (userFilteredCategories.length > newTeamArr.length) {
          optionsArray.push(PERSONA_OPTIONS.is_cwf);
        }
      }

      if (
        employee_org_permission &&
        employee_org_permission?.employee_org_permission.length > 0
      ) {
        const currentPermissions =
          employee_org_permission?.employee_org_permission.find(
            (p) => p.employee_id === currentUser?.id
          );

        if (currentPermissions?.auth_details) {
          const exists = currentPermissions?.auth_details.find((p) => {
            if (p?.name === "pdf_enabled") {
              return true;
            }
            if (p.length > 0) {
              return p[0].name === "pdf_enabled";
            }
            return false;
          });

          if (exists) {
            setPDFEnabled(true);
            optionsArray.push(PERSONA_OPTIONS.pdf_enabled);
          }
        } else {
          setPDFEnabled(false);
        }
      }

      const persona = PERSONAS.find((p) => {
        return p.options.sort().join(",") === optionsArray.sort().join(",");
      });

      if (persona) {
        setPersona(persona);
      }
    }
  }, [
    currentUser,
    isOtp,
    userFilteredCategories,
    get_survey_structure,
    employee_org_permission,
  ]);

  useEffect(() => {
    if ((canEdit || canAccessData) && !userFilteredCategories) {
      if (isAdmin) {
        const filterCat = get_survey_structure?.[0]?.categories.filter(
          (c) => c.priority === "primary"
        )?.[0]?.options;
        setUserFilteredCategories(filterCat);

        return;
      }

      if (employeeCategories?.category?.length > 0) {
        const filterCat = employeeCategories?.category
          .filter((c) => {
            return c?.priority === "primary";
          })
          .map((c) => c.value_id);

        setUserFilteredCategories(filterCat);

        return;
      }
    }
  }, [
    currentUser,
    employeeCategories,
    canEdit,
    canAccessData,
    get_survey_structure,
  ]);

  useEffect(() => {
    if (Number(AmbassadorId) > 0) {
      setOrganization(get_organizations[get_selectedOrg?.organization?.id]);
    } else {
      setOrganization(get_organizations[get_auth?.organization_id]);
    }

    if (get_organizations) {
      const isOTPType = get_organizations.organization.services_enabled?.find(
        (f) => f.name === "OTP"
      )?.enabled;

      setIsOtp(isOTPType);
    }
  }, [get_organizations, get_selectedOrg, AmbassadorId, get_auth]);

  useEffect(() => {
    if (organization?.services_enabled) {
      let audit = false;

      organization?.services_enabled.map((i) => {
        if (["Audit", "OTP", "EDI"].includes(i.name) && i.enabled) {
          audit = true;
        }
        return null;
      });
      setAuditEnabled(audit);
      setTeamToolEnabled(
        organization.services_enabled.find((f) => f.name === "Teamtool")
          ?.enabled
      );
    }
  }, [organization]);

  useEffect(() => {
    let selectedTeam = selectTeam ? selectTeam : false;
    if (userAdmin) {
      setAdministrator(true);
    }
    if (Number(EmployeeId) > 0) {
      // setEmployee(get_employees[Number(EmployeeId)]);
      // team leader
      if (get_employees[Number(EmployeeId)]?.role < 7) {
        setTeamLeader(true);

        // console.log("I was here set as team leader")
        if (get_employees[Number(EmployeeId)]?.team) {
          setSelectTeam(get_employees[Number(EmployeeId)]?.team);
        }
      }
      // admin
      if (get_employees[Number(EmployeeId)]?.account_type < 7) {
        // setTeamLeader(true);
        setAdministrator(true);
        setSelectTeam(selectedTeam);
      }
    }
    if (Number(AmbassadorId) > 0) {
      // set role and account
      setTeamLeader(true);
      setAdministrator(true);
      setSelectTeam(selectedTeam);
      // console.log("I am here")
    }
  }, [
    userAdmin,
    get_teams,
    get_employees,
    AmbassadorId,
    EmployeeId,
    selectTeam,
  ]);

  // Get active members from employee_org_category (now includes employee data)
  const activeMembers = useMemo(() => {
    // Transform category entries into member objects
    const members = get_employee_org_category
      .filter((entry) => {
        // Filter by employee_status (exclude inactive statuses: 99, 98, 108)
        const status = entry?.employee_status;
        return status !== 99 && status !== 98 && status !== 108;
      })
      .map((entry, index) => {
        // DEBUG: Log what we're trying to extract for name
        const fullName = entry?.employee_full_name || "";
        const employeeObj = entry?.employee;

        // Parse employee_full_name into first_name and last_name
        let first_name = "";
        let last_name = "";
        let email = entry?.employee_email || "";

        // Try multiple ways to get the name
        if (fullName) {
          const nameParts = fullName.trim().split(/\s+/);
          if (nameParts.length > 0) {
            first_name = nameParts[0];
            if (nameParts.length > 1) {
              last_name = nameParts.slice(1).join(" ");
            }
          }
        } else if (employeeObj && typeof employeeObj === 'object') {
          // If employee is an object, try to get name from there
          first_name = employeeObj?.first_name || "";
          last_name = employeeObj?.last_name || "";
          email = employeeObj?.email || email;
        }

        const member = {
          id: entry?.employee_id || entry?.employee,
          first_name,
          last_name,
          email,
          status: entry?.employee_status,
          created_at: entry?.created_at,
          updated_at: entry?.updated_at,
          // Preserve other employee properties that might be needed
          account_type: entry?.employee_account_type,
          enable_login: entry?.employee_enable_login,
          survey_add_users: entry?.employee_survey_add_users,
          access_data_analytics: entry?.employee_access_data_analytics,
          access_subfactor_data: entry?.employee_access_subfactor_data,
          read_feedback: entry?.employee_read_feedback,
          survey_schedule: entry?.employee_survey_schedule,
          survey_status: entry?.employee_survey_status,
          role: entry?.employee_role,
          team: entry?.employee_team,
        };

        return member;
      });

    // Sort by id (maintaining existing behavior)
    return members.sort((a, b) => (a.id > b.id ? 1 : -1));
  }, [get_employee_org_category]);

  // Update members and memberList when activeMembers changes
  useEffect(() => {
    setMembers(activeMembers);
    setMemberList(activeMembers);
  }, [activeMembers]);

  useEffect(() => {
    if (get_employees) {
      setCurrentUser(get_employees?.userEmp);
    }
  }, [get_employees]);

  useEffect(() => {
    if (currentUser?.account_type === 5) {
      setIsAdmin(true);
    }
    if (currentUser?.survey_add_users === 1) {
      setCanEdit(true);
    }
    if (currentUser?.access_data_analytics === 1) {
      setCanAccessData(true);
    }
  }, [currentUser]);

  useEffect(() => {
    if (
      filteredCategoriesSelected.length === 0 ||
      filteredPermissions.length === 0 ||
      !missingCategoriesFilter
    ) {
      setMemberList(members);
      // Re-run search to retain old list
      searchMembers(search, true);
    }

    if (
      filteredCategoriesSelected.length > 0 &&
      get_employee_org_category &&
      // used to keep loading spinner in cases where the get_employee_org_category is empty
      (memberList.length <= get_employee_org_category.length ||
        get_employee_org_category.length > 1)
    ) {
      // members
      // memberList
      const listToFilter =
        (memberList.length > 0 && search?.length > 0 && memberList) || members;
      const filteredMemberList = listToFilter.filter((member) => {
        let isValidMember = true;
        const employeeCategories = get_employee_org_category?.find(
          (emp) => (emp.employee_id || emp.employee) === member.id
        );
        filteredCategoriesSelected.forEach((category) => {
          // Reset on each
          const categoryName = filterCategories
            ?.find((fg) => {
              return fg?.priority === "primary";
            })
            ?.options.find((fc) => {
              return fc.id === category;
            });

          const empCats = employeeCategories?.category?.map((cat) => {
            return cat?.value_id;
          });

          if (isValidMember) {
            isValidMember =
              empCats?.includes(category) ||
              empCats?.includes(categoryName?.text);
          }
          // employeeCategories?.category?.forEach((cat) => {
          //   if (!isValidMember) {
          //     isValidMember =
          //       category === cat?.value_id ||
          //       categoryName?.text === cat?.value_id;
          //   }
          // });
        });
        return isValidMember;
      });
      setMemberList(filteredMemberList);
    }

    if (filteredPermissions.length > 0) {
      const listToFilter =
        filteredCategoriesSelected.length > 0 || search.length > 0
          ? memberList
          : members;
      const filteredMemberList = listToFilter.filter((member) => {
        let isValidMember = false;
        filteredPermissions.forEach((perm) => {
          // Account types have diff value than 1
          if (perm === "account_type") {
            isValidMember = member[perm] === 5;
          } else if (perm === "enable_login") {
            isValidMember = member[perm];
          } else {
            isValidMember = member[perm] === 1;
          }
        });
        return isValidMember;
      });
      setMemberList(filteredMemberList);
    }

    if (missingCategoriesFilter) {
      const listToFilter =
        filteredCategoriesSelected.length > 0 || search.length > 0
          ? memberList
          : members;

      const filteredMemberList = listToFilter.filter((item, i) => {
        let missingFields = [];
        filterCategories.forEach((cat) => {
          const userCategory = get_employee_org_category.find(
            (c) => (c?.employee_id || c?.employee) === item.id
          );
          if (userCategory && cat?.visibility !== "private") {
            if (cat?.priority === "primary" || cat?.priority === "secondary") {
              const hasField = userCategory?.category.find(
                (uc) => uc?.priority === cat?.priority
              );

              if (
                (!hasField && !missingFields.includes(cat?.category)) ||
                (hasField &&
                  !cat?.options.find((op) => op.text === hasField?.value))
              ) {
                missingFields.push(cat?.category);
              }
            } else {
              const hasField = userCategory?.category.find(
                (uc) => uc?.name === cat?.category
              );
              if (!hasField && !missingFields.includes(cat?.category)) {
                missingFields.push(cat?.category);
              }
            }
          }
        });

        if (!item.email) {
          missingFields.push("Email");
        }

        if (!item.first_name) {
          missingFields.push("First Name");
        }

        if (!item.last_name) {
          missingFields.push("Last Name");
        }

        missingFields = missingFields.filter((f) => !!f);
        return missingFields.length > 0;
      });
      setMemberList(filteredMemberList);
      if (hideMembers) {
        const newMembersList = memberList.filter(
          (member) => member?.id === currentUser?.id
        );
        setMemberList(newMembersList);
        setMembers(newMembersList);
      }
    }

    setPage(1);
  }, [
    filteredCategoriesSelected,
    filteredPermissions,
    missingCategoriesFilter,
  ]);

  useEffect(() => {
    if (
      persona &&
      persona?.text === "CWF" &&
      memberList?.length > 0 &&
      !membersFiltered
    ) {
      let showMembers = false;
      if (
        currentUser &&
        currentUser?.employee_employee_category?.category?.length > 0
      ) {
        currentUser?.employee_employee_category?.category?.forEach(
          (category) => {
            if (category?.priority === "primary" && category?.group) {
              showMembers = true;
            }
          }
        );
      }
      if (!showMembers) {
        setHideMembers(true);
      }
      setMembersFiltered(true);
    }
  }, [memberList, persona, currentUser]);

  useEffect(() => {
    let selectedTeam = selectTeam ? selectTeam : false;
    if (userAdmin) {
      setAdministrator(true);
    }
    if (Number(EmployeeId) > 0) {
      // setEmployee(get_employees[Number(EmployeeId)]);
      // team leader
      if (get_employees[Number(EmployeeId)]?.role < 7) {
        setTeamLeader(true);

        // console.log("I am here set as team leader")
        if (get_employees[Number(EmployeeId)]?.team) {
          setSelectTeam(get_employees[Number(EmployeeId)]?.team);
        }
      }
      // admin
      if (get_employees[Number(EmployeeId)]?.account_type < 7) {
        // setTeamLeader(true);
        setAdministrator(true);
        setSelectTeam(selectedTeam);
      }
    }
    if (Number(AmbassadorId) > 0) {
      // set role and account
      setTeamLeader(true);
      setAdministrator(true);
      setSelectTeam(selectedTeam);
    }
  }, [
    userAdmin,
    get_teams,
    get_employees,
    AmbassadorId,
    EmployeeId,
    selectTeam,
  ]);


  useEffect(() => {
    // When component mounts and there's a search term, re-filter the list
    if (search && members?.length > 0) {
      searchMembers(search, true);
      // also update the member list
      setMemberList(members.filter((member) => member.email.toLowerCase().includes(search.toLowerCase())));
    }
  }, [search]); // empty dependency array ensures this runs once on mount


  useEffect(() => {
    // if (members.length > 0) {
    const timer1 = setTimeout(() => {
      if (setLoading) {
        setLoading(false);
        setTimeoutReached(true);
      }
    }, 30000);
    return () => clearTimeout(timer1);
    // }
  }, [members]);

  const handlePaginationChange = (e, { activePage }) => {
    setPage(activePage);
  };

  // Reset to page 1 when items per page changes
  useEffect(() => {
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    if (get_employees?.updated && setTeamUpdate) {
      setTeamUpdate(get_employees?.update?.id);
    }
  }, [get_employees, setTeamUpdate]);

  useEffect(() => {
    if (
      get_survey_structure?.[0] &&
      get_employee_org_category &&
      get_employee_org_category.length > 0 &&
      filterCategories &&
      categoriesFetched
    ) {
      setLoading(false);
    } else {
      if (!categoriesFetched) {
        setLoading(true);
      }
      if (categoriesFetched || timeoutReached) {
        setLoading(false);
      }
    }
  }, [
    get_survey_structure,
    get_employee_org_category,
    filterCategories,
    categoriesFetched,
    timeoutReached,
  ]);

  useEffect(() => {
    if (get_survey_structure && get_survey_structure[0]) {
      const filterOptions = get_survey_structure[0]?.categories?.map((cat) => {
        const categoryName = cat.name;
        const categoryOptions = [];
        cat.options.forEach((op) => {
          if (op?.subfactors?.length > 0) {
            op?.subfactors.forEach((sf) => {
              categoryOptions.push({
                text: sf.name,
                value: sf.name,
                id: sf.id,
                subfactorId: sf.id,
                isSubfactor: true,
              });
            });
          } else {
            categoryOptions.push({
              text: op.name,
              value: op.name,
              id: op.id,
            });
          }
        });

        // Only allow if visibility is not private
        if (cat.visibility !== "private") {
          return {
            category: categoryName,
            priority: cat.priority,
            options: [...categoryOptions],
          };
        }
      });
      setFilterCategories(filterOptions);
    }
  }, [get_survey_structure, userFilteredCategories, isAdmin]);

  useEffect(() => {
    setAddUploadUsers(
      userEmployee?.account_type === 5 || userEmployee?.survey_add_users === 1
    );
  }, [userEmployee]);

  function searchMembers(e, useList) {
    setSearch(e);
    setIsTyping(true);
    let emailLst = [];
    let firstList = [];
    let lastList = [];
    const listToFilter =
      (memberList.length > 0 && !useList && memberList) || members;
    if (e.length > 0) {
      setPage(1);
      emailLst = listToFilter.filter((item) =>
        item?.email?.toLowerCase().includes(e.toLowerCase())
      );
      firstList = listToFilter.filter((item) => {
        const name =
          item?.first_name?.toLowerCase() +
          " " +
          item?.last_name?.toLowerCase();
        return name.includes(e.toLowerCase());
      });
      const _MemberList = emailLst.concat(firstList);
      const newList = _MemberList.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      setMemberList(newList);
      if (memberFilters?.search !== e) {
        dispatch({
          type: SG_SET_MEMBER_SEARCH_FILTERS,
          payload: {
            search: e,
          },
        });
      }
    } else {
      setMemberList(listToFilter);
    }
  }

  const newMembersList = memberList?.filter(
    (member) => member?.id === currentUser?.id
  );

  return (
    <Dimmer.Dimmable blurring dimmed={loading}>
      {changesMade && (
        <Message
          onDismiss={() => {
            setChangesMade(false);
          }}
          color={changesMade?.color}
        >
          {changesMade?.message}
        </Message>
      )}

      <TopTitle>
        <Title>Member Management</Title>
        <Image src={MemberIcon} />
        <Sub>Member</Sub>
      </TopTitle>
      {((canEdit || isAdmin) && (
        <TopSection>
          <div style={{ display: "flex" }}>
            <RedirectLink
              to={`members/new-member`}
              style={{
                alignSelf: "center",
                justifyContent: "center",
              }}
            >
              <MemberInviteButton>
                <IconWrapper>{PlusIcon()}</IconWrapper>
                <InviteText>Invite Contact</InviteText>
              </MemberInviteButton>
            </RedirectLink>
            <RedirectLink
              to={`members/inactive`}
              style={{
                alignSelf: "center",
                justifyContent: "center",
              }}
            >
              <Archive>
                <InviteText>Archived</InviteText>
              </Archive>
            </RedirectLink>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <RedirectLink
              to={`members/upload`}
              style={{
                alignSelf: "center",
                justifyContent: "center",
                marginRight: 20,
              }}
            >
              <UploadCsvWrapper>
                <UploadIcon>{UploadGroupIcon()}</UploadIcon>
                <UploadCsvText>Upload</UploadCsvText>
              </UploadCsvWrapper>
            </RedirectLink>
            <RedirectLink
              to={`members/update`}
              style={{
                alignSelf: "center",
                justifyContent: "center",
              }}
            >
              <UploadCsvWrapper>
                <UploadIcon>{RefreshIcon()}</UploadIcon>
                <UploadCsvText>Update</UploadCsvText>
              </UploadCsvWrapper>
            </RedirectLink>
          </div>
        </TopSection>
      )) || <Divider />}
      <Container>
        <SearchContainer>
          <Input
            icon="search"
            iconPosition="left"
            placeholder="Search..."
            size="small"
            style={{ width: "70%" }}
            value={search}
            onChange={(e) => searchMembers(e.target.value, false)}
          />
        </SearchContainer>
        <FilterBar>
          {get_survey_structure?.[0] && (
            <ModernFilter
              categories={get_survey_structure?.[0]?.categories}
              setFilterCategories={(f) => setFilteredCategoriesSelected(f)}
              setFilterPermissions={(f) => setFilteredPermissions(f)}
              setMissingCategoriesFilter={(f) => setMissingCategoriesFilter(f)}
              resetMemberList={() => {
                setMemberList([]);
                setFilteredPermissions([]);
                setFilteredCategoriesSelected([]);
                setMissingCategoriesFilter(false);
              }}
            />
          )}
        </FilterBar>

        <TableWrapper>
          <TableList
            members={
              hideMembers
                ? newMembersList
                : filteredCategoriesSelected.length > 0 ||
                  filteredPermissions.length > 0 ||
                  missingCategoriesFilter ||
                  search.length > 0
                  ? memberList
                  : memberList
            }
            categories={get_employee_org_category}
            filterCategories={filterCategories}
            setLoadingCb={(l) => setLoading(l)}
            structure={get_survey_structure[0]}
          />
        </TableWrapper>
        <PaginationContainer>
          <ItemsPerPageWrapper>
            <ItemsPerPageLabel>Show:</ItemsPerPageLabel>
            <Dropdown
              selection
              compact
              value={itemsPerPage}
              onChange={(e, { value }) => setItemsPerPage(value)}
              options={[
                { key: 10, text: '10', value: 10 },
                { key: 20, text: '20', value: 20 },
                { key: 50, text: '50', value: 50 },
                { key: 100, text: '100', value: 100 },
              ]}
            />
          </ItemsPerPageWrapper>
          <Pagination
            activePage={page}
            onPageChange={handlePaginationChange}
            boundaryRange={1}
            size="mini"
            firstItem={null}
            lastItem={null}
            siblingRange={0}
            totalPages={
              hideMembers
                ? 1
                : Math.ceil((get_employee_org_category_pagination?.count || 0) / itemsPerPage)
            }
          />
        </PaginationContainer>
      </Container>

      <Dimmer active={loading}>
        <LoadingContainer>
          <p>Loading page</p>
          <Loader size="medium">Loading</Loader>
        </LoadingContainer>
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

export default MemberDirectory;

const Container = styled.div`
  padding-left: 58px;
  margin-bottom: 50px;
`;

const TopTitle = styled.div`
  width: 100%;
  padding-left: 58px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  margin-top: -20px;
`;

const Title = styled.div`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height */

  display: flex;
  align-items: center;
  text-transform: capitalize;

  color: #414141;

  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;

const Image = styled.img`
  margin-right: 8px;
  margin-left: 19px;
`;

const Sub = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;

  color: #7e7e7e;
`;

const TableWrapper = styled.div`
  z-index: 20;
  position: relative;
`;

const IconWrapper = styled.div`
  line-height: 21.86px;
  margin-right: 5px;
  height: 100%;
  display: flex;
  align-items: center;
`;

const InviteText = styled.label`
  font-family: "Inter";
  font-style: normal;
  justify-content: center;
  font-weight: 300;
  font-size: 10px;
  line-height: 21.86px;
  cursor: pointer;
  color: white;
`;

const MemberInviteButton = styled.div`
  display: flex;
  width: 99px;
  height: 21.86px;
  cursor: pointer;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background-color: #476dfa;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;

  color: #ffffff;
`;

const Archive = styled.div`
  display: flex;
  width: 81px;
  height: 21.86px;
  cursor: pointer;
  border-radius: 30px;
  align-self: center;
  justify-content: center;
  background-color: #515151;
  margin-left: 10px;
  border: 1px solid #414141;
  border-radius: 100px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
`;

const TopSection = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px;
  border-bottom: 1px;
  border-color: #dfdfdf;
  border-style: solid;
  border-right: 0px;
  border-left: 0px;
  height: 58px;
  justify-content: space-between;
  padding-left: 58px;
  padding-right: 10px;
`;

const UploadCsvWrapper = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-self: center;
`;

const UploadCsvText = styled.label`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  height: 20px;
  align-self: center;
  color: #7e7e7e;
  cursor: pointer;
`;

const FilterBar = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FilterTopRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
`;

const UploadIcon = styled.div`
  margin-right: 5px;
`;

const Table = styled.div`
  width: 100%;
`;
const Headers = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e9e9e9;
`;

const TH = styled.div`
  font-size: 14px;
  font-family: "Red Hat Display", sans-serif;
  color: #4a4a4a;
  width: ${(props) => props.width + "%"};
  padding: 0 0 10px 15px;
`;

const NavContainer = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #d3dbdb;
`;

const NavTitle = styled.div`
  font-family: "Red Hat Display", sans-serif;
  font-size: 16px;
  font-weight: bold;
  margin-right: 20px;
`;

const SearchContainer = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  position: relative;
`;

const StyledButton = styled.button`
  color: white;
  font-size: 14px;
  font-family: "Barlow Semi Condensed", sans-serif;
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  background-color: #2d50e2;
  border: none;
  outline: none;
  margin-top: 30px;
  padding: 0px 30px;
  border: 1px solid white;

  @media (max-width: 768px) {
    height: 30px;
    font-size: 12px;
    padding: 0 10px 0 10px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0);
    border: 1px solid #2d50e2;
    color: #2d50e2;
  }
`;

const LoadingContainer = styled.div`
  min-height: 40vh;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  position: relative;
  z-index: 100;
`;

const ItemsPerPageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 101;
`;

const ItemsPerPageLabel = styled.span`
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #6b7280;
`;
